import { RootState, AppDispatch } from "../store/index";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

// Use these throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
